export const SPECIALS = {
  teleport: {
    name: "Teleport",
    cooldown: 2,
    action: "teleport",
    type: "instant",
    description:
      "Move a character (that's within 9 inches of you) up to 9 inches in any direction",
  },
  enlighten: {
    name: "Enlighten",
    cooldown: 2,
    action: "chooseEnlightenTarget",
    description: "Grant experience to an ally",
  },
  empower: {
    name: "Empower",
    cooldown: 2,
    action: "chooseEmpowerTarget",
    description: "Restore stamina to an ally",
  },
  aura_of_protection: {
    name: "Aura of Protection",
    cooldown: 3,
    action: "chooseAuraOfProtectionTarget",
    description: "Protect an ally from damage for 1 turn",
  },
  fortify: {
    name: "Fortify",
    cooldown: 2,
    action: "fortify",
    type: "instant",
    description: "Build a barrier, which cannot be jumped over.",
  },
  hook: {
    name: "Hook",
    cooldown: 2,
    action: "hook",
    type: "instant",
    description: "Pull a character within 7 inches towards you",
  },
  toss: {
    name: "Toss",
    cooldown: 2,
    action: "toss",
    type: "instant",
    description: "Toss a nearby character",
  },
  leap: {
    name: "Leap",
    cooldown: 2,
    action: "leap",
    type: "instant",
    description: "Jump upwards 4 inches",
  },
  battle_cry: {
    name: "Battle Cry",
    cooldown: 1,
    action: "chooseBattleCryTargets",
    description: "Increase the attack of nearby allies",
    benefits: {
      attack: 6,
    },
  },
  stun: {
    name: "Stun",
    cooldown: 2,
    action: "chooseStunTarget",
    description: "Try to stun an opponent for 1 turn",
  },
  rage: {
    name: "Rage",
    cooldown: 2,
    action: "rage",
    type: "instant",
    description: "Gain extra stamina",
  },
  circle_of_pain: {
    name: "Circle of Pain",
    cooldown: 3,
    action: "chooseCircleOfPainTargets",
    description: "Deal damage to nearby opponents",
  },
  split_self: {
    name: "Split Self",
    cooldown: 1,
    action: "split_self",
    type: "instant",
    description: "Make two kamikaze's, with half health",
  },
  back_off: {
    name: "Back Off",
    cooldown: 2,
    action: "back_off",
    type: "instant",
    description: "Push all nearby opponents away",
  },
  knock_down: {
    name: "Knock Down",
    cooldown: 3,
    action: "chooseKnockDownTarget",
    description: "Try to push a target back",
  },
  revive: {
    name: "Revive",
    cooldown: 4,
    action: "chooseReviveTarget",
    description: "Bring a character back to life.",
  },
  spawn: {
    name: "Spawn",
    cooldown: 4,
    action: "spawn",
    type: "instant",
    description: "Raise a skeleton ally with full stamina",
  },
  mind_control: {
    name: "Mind Control",
    cooldown: 4,
    action: "chooseMindControlTarget",
    description:
      "Take control of an enemy until the end of your turn (cannot target Balls of Steel).",
  },
  rally_the_troops: {
    name: "Rally the Troops",
    cooldown: 2,
    action: "rally_the_troops",
    type: "instant",
    description: "Bring all nearby allies towards you, up to 6 inches",
  },
  poison_shot: {
    name: "Poison Shot",
    cooldown: 3,
    action: "choosePoisonShotTarget",
    description: "Poison a target within 18 inches.",
  },
};
